var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 9C16.7778 9 18.4444 8.25 19.5 7H10.5C11.5556 8.25 13.2222 9 15 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3C15.2761 3 15.5 2.77614 15.5 2.5C15.5 2.22386 15.2761 2 15 2C14.7239 2 14.5 2.22386 14.5 2.5C14.5 2.77614 14.7239 3 15 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2778 17L8.5 18.6119L11.0556 21L12.7778 19.1493C12.8333 18.5522 13.1111 18.0149 13.5 17.6567L13.0556 17.4776C12.8333 17.2985 12.5556 17.1791 12.2778 17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1 17.4242L16.5 17.6061C16.9667 17.9697 17.3 18.5152 17.3667 19.1212L19.4333 21L22.5 18.5758L18.0333 17C17.7 17.1818 17.3667 17.303 17.1 17.4242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 21C16.0523 21 16.5 20.3284 16.5 19.5C16.5 18.6716 16.0523 18 15.5 18C14.9477 18 14.5 18.6716 14.5 19.5C14.5 20.3284 14.9477 21 15.5 21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 22V28.8652L15.5 30L16.5 28.8652V22C15.9 22.4539 15.1 22.4539 14.5 22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3004 22.4513L17.6088 20.7257V28.7788L15.2757 31.0796L12.9426 28.7788V20.7257L11.2511 22.3938L7.28475 19L5.82654 19.5752C3.78505 20.323 2.4435 22.2788 2.50183 24.4071V32H7.75137V26.2478H8.91794V32H20.7002C20.6419 31.8274 20.5836 31.5973 20.5836 31.4248V23.9469C20.5836 22.969 21.3419 22.2212 22.3334 22.2212H23.5V19.115L23.3833 19.0575L19.3004 22.4513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.44977 5H20.4909L21.4406 3C21.5 2.95 21.5 2.85 21.5 2.8V1.35C21.5 1.1 21.2626 0.9 21.0251 0.85L15.089 0C15.0297 0 14.9703 0 14.911 0L8.97489 0.85C8.67808 0.9 8.5 1.1 8.5 1.35V2.8C8.5 2.85 8.5 2.95 8.55936 3L9.44977 5ZM14.9703 1C15.9795 1 16.7511 1.65 16.7511 2.5C16.7511 3.35 15.9795 4 14.9703 4C13.9612 4 13.1895 3.35 13.1895 2.5C13.1895 1.65 13.9612 1 14.9703 1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02282 10.2536L10.2427 10.8892V11.236C10.2427 13.6051 11.695 15.7432 13.9025 16.61L14.4253 16.7833C15.1224 17.0722 15.8776 17.0722 16.5747 16.7833L17.0975 16.61C19.305 15.7432 20.7573 13.6051 20.7573 11.236V10.8892L22.0353 10.2536C22.3257 10.138 22.5 9.79133 22.5 9.50241V8.86677C22.5 8.40449 22.0934 8 21.6286 8H20.6992C18.0851 10.8892 13.612 11.0626 10.7075 8.46228C10.5332 8.28892 10.3589 8.17335 10.2427 8H9.37137C8.90664 8 8.5 8.40449 8.5 8.86677V9.50241C8.5 9.84912 8.73236 10.138 9.02282 10.2536Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};

export default __webpack_public_path__ + "static/media/customs.f8494bce.svg";
export { SvgComponent as ReactComponent };